module.exports = __webpack_public_path__ + "media/images/logo-old-653ea29135160d26b25e62601d4dccc2.png";